var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 83.3334V218.75M125 83.3334C121.232 67.8063 114.744 54.532 106.383 45.2413C98.0211 35.9507 88.1738 31.075 78.125 31.2501C71.2183 31.2501 64.5945 33.9937 59.7108 38.8775C54.827 43.7612 52.0833 50.385 52.0833 57.2917C52.0833 64.1984 54.827 70.8222 59.7108 75.706C64.5945 80.5897 71.2183 83.3334 78.125 83.3334M125 83.3334C128.768 67.8063 135.256 54.532 143.617 45.2413C151.979 35.9507 161.826 31.075 171.875 31.2501C178.782 31.2501 185.405 33.9937 190.289 38.8775C195.173 43.7612 197.917 50.385 197.917 57.2917C197.917 64.1984 195.173 70.8222 190.289 75.706C185.405 80.5897 178.782 83.3334 171.875 83.3334M197.917 125V197.917C197.917 203.442 195.722 208.741 191.815 212.648C187.908 216.555 182.609 218.75 177.083 218.75H72.9167C67.3913 218.75 62.0923 216.555 58.1853 212.648C54.2783 208.741 52.0833 203.442 52.0833 197.917V125M41.6667 83.3334H208.333C214.086 83.3334 218.75 87.9971 218.75 93.7501V114.583C218.75 120.336 214.086 125 208.333 125H41.6667C35.9137 125 31.25 120.336 31.25 114.583V93.7501C31.25 87.9971 35.9137 83.3334 41.6667 83.3334Z",
    stroke: "var(--ion-color-primary)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.ba2d1a0ce104f94c4469723ef71c7f44.svg";
export { ForwardRef as ReactComponent };